import { NgModule } from '@angular/core';

import * as FileSubmissionServiceProxies from './file-submission-service-proxies';

@NgModule({
    providers: [
        FileSubmissionServiceProxies.ServiceProxy
    ]
})
export class FileSubmissionServiceProxyModule { }
